import { decorate, observable, action, runInAction } from 'mobx';
import CommonStore from "modules/CommonStore";
import ApiClient from "./api";

class OrdersClassesStore extends CommonStore {
  constructor(rootStore: RootStoreInterface) {
    const apiClient = new ApiClient(rootStore.apiClient);
    super(
      rootStore,
      apiClient,
      rootStore.specifications["OrdersClasses"]
    );
  }

}

decorate(OrdersClassesStore, {

});

export default OrdersClassesStore;
